import { render } from "./NewVersionModal.vue?vue&type=template&id=02ea77f4&ts=true"
import script from "./NewVersionModal.vue?vue&type=script&lang=ts"
export * from "./NewVersionModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__